import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';

import { Metric } from '../../interfaces/metric.interface';
import { StaticMetricMenuItem } from 'Angular/services/static-menus/interfaces/static-metric-menu.interface';
import { GlossaryCalcTerm } from 'GlossaryApp/ts/interfaces/glossary-term.interface';

import { YChartsSentryUtils } from 'Angular/services/sentry/sentry-utils';
import { GlossaryService } from 'GlossaryApp/ts/services/glossary.service';

import { decodeHtml } from 'Angular/utils/html-transcode';

/**
 * Metric Info Modal
 *
 * A modal that displays when the user clicks the info icon next to a metric in the metric modal.
 * For the corresponding metric, this info modal shows the available asset types and other information such as the
 * definition and formula.
 */
@Component({ standalone: false, selector: 'ycn-metric-info-modal', templateUrl: './metric-info-modal.template.html' })
export class MetricInfoModalComponent {
    glossaryTerm: GlossaryCalcTerm | null = null;

    isOpen: boolean = false;

    metric: Metric | StaticMetricMenuItem | null = null;

    constructor(private glossaryService: GlossaryService) {}

    openModal(metric: Metric | StaticMetricMenuItem): void {
        this.isOpen = true;
        this.metric = metric;

        this.glossaryService.getGlossaryCalcTerm(metric.internal_name).subscribe({
            next: (glossaryTerm) => {
                if (Object.keys(glossaryTerm)) {
                    this.glossaryTerm = glossaryTerm as GlossaryCalcTerm;
                    this.glossaryTerm.sections[0].content = decodeHtml(this.glossaryTerm.sections[0].content, '<br>');
                    this.glossaryTerm.sections[1].content = decodeHtml(this.glossaryTerm.sections[1].content, '<br>');
                } else {
                    this.glossaryTerm = null;
                }
            },
            error: (error: HttpErrorResponse) => {
                if (error.status !== 404) {
                    YChartsSentryUtils.captureException(error);
                }
            },
        });
    }

    closeModal(): void {
        this.isOpen = false;
        this.metric = null;
        this.glossaryTerm = null;
    }
}
